var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#949090",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.332 39.4375C22.3324 39.0233 22.4973 38.6261 22.7904 38.3334L30.782 30.3417C31.0239 30.0999 31.2158 29.8128 31.3467 29.4968C31.4776 29.1808 31.545 28.8421 31.545 28.5C31.545 28.158 31.4776 27.8193 31.3467 27.5033C31.2158 27.1873 31.0239 26.9002 30.782 26.6584L22.8008 18.6719C22.5162 18.3772 22.3587 17.9825 22.3622 17.5728C22.3658 17.1632 22.5301 16.7713 22.8198 16.4816C23.1095 16.1919 23.5014 16.0275 23.9111 16.024C24.3208 16.0204 24.7155 16.1779 25.0102 16.4625L32.9914 24.4427C34.0646 25.518 34.6673 26.9751 34.6673 28.4943C34.6673 30.0135 34.0646 31.4706 32.9914 32.5459L24.9997 40.5375C24.7815 40.7559 24.5035 40.9047 24.2008 40.9652C23.8981 41.0257 23.5843 40.9952 23.2989 40.8776C23.0135 40.7599 22.7694 40.5603 22.5973 40.304C22.4252 40.0477 22.3329 39.7462 22.332 39.4375V39.4375Z",
    fill: "#545353"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d59076147fb9e066c6977dc4f81f0594.svg";
export { ForwardRef as ReactComponent };